import React from 'react';
import ModalDialogeStyled, { ModalSize } from './ModalDialogue.styled';

export interface ModalDialogueProps {
  isVisible: boolean;
  title: string;
  primaryButtonLabel: string;
  secondaryButtonLabel?: string;
  onClose?: (...arg: any[]) => any;
  secondaryAction?: (...arg: any[]) => any;
  primaryAction: (...arg: any[]) => any;
  primaryActionDisabled?: boolean;
  primaryIcon?: string;
  secondaryIcon?: string;
  showPrimaryButton?: boolean;
  children: React.ReactNode;
  size?: ModalSize;
}

const ModalDialogue: React.FC<ModalDialogueProps> = ({
  isVisible,
  title,
  primaryButtonLabel,
  secondaryButtonLabel,
  size = 'lg',
  children,
  primaryActionDisabled = false,
  primaryIcon = 'fa-save',
  secondaryIcon = 'fa-close',
  showPrimaryButton = true,
  onClose,
  secondaryAction,
  primaryAction,
}) => {
  if (!isVisible) return null;

  return (
    <>
      <div className={`modal fade show`} style={{ display: 'block' }} tabIndex={-1} role="dialog">
        <div className={size === 'md' ? 'modal-dialog' : `modal-dialog modal-${size}`} role="document">
          <ModalDialogeStyled.ModalContent>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                  <span>&times;</span>
                </button>
              </div>
              <ModalDialogeStyled.ModalBody size={size}>{children}</ModalDialogeStyled.ModalBody>
              <div className="modal-footer">
                {secondaryAction && (
                  <button type="button" className="btn btn-secondary" onClick={secondaryAction}>
                    <i className={`fa ${secondaryIcon}`}></i> {secondaryButtonLabel}
                  </button>
                )}
                {showPrimaryButton && (
                  <button type="button" className="btn btn-primary" disabled={primaryActionDisabled} onClick={primaryAction}>
                    <i className={`fa ${primaryIcon}`}></i> {primaryButtonLabel}
                  </button>
                )}
              </div>
            </div>
          </ModalDialogeStyled.ModalContent>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
};

export default ModalDialogue;
